/**
 * Generic Slick Carousel Initializer
 * Finds all elements with [data-slick-carousel] and initializes them
 * using settings provided in data-slick-settings (JSON)
 */

function initCustomCarousels(force = false) {
  const carousels = document.querySelectorAll('[data-slick-carousel]');

  carousels.forEach((carousel) => {
    const $carousel = $(carousel);

    // Get custom settings from data attribute
    let settings = {};
    try {
      const settingsData = carousel.getAttribute('data-slick-settings');
      if (settingsData) {
        settings = JSON.parse(settingsData);
      }
    } catch (e) {
      console.error('Error parsing slick settings:', e);
    }

    const prevArrowId = carousel.getAttribute('data-prev-arrow-id');
    const nextArrowId = carousel.getAttribute('data-next-arrow-id');

    if (prevArrowId) {
      const prevTemplate = document.getElementById(prevArrowId);
      if (prevTemplate) {
        settings.prevArrow = prevTemplate.innerHTML;
      }
    }

    if (nextArrowId) {
      const nextTemplate = document.getElementById(nextArrowId);
      if (nextTemplate) {
        settings.nextArrow = nextTemplate.innerHTML;
      }
    }

    const dotsContainerId = carousel.getAttribute('data-dots-id');
    if (dotsContainerId) {
      const dotsContainer = document.getElementById(dotsContainerId);
      if (dotsContainer) {
        settings.appendDots = $(dotsContainer);
      }
    }

    const dotTemplateId = carousel.getAttribute('data-dot-template-id');
    if (dotTemplateId) {
      const template = document.getElementById(dotTemplateId);
      if (template) {
        settings.customPaging = function (slider, i) {
          return template.innerHTML;
        };
      }
    }

    if ($carousel.hasClass('slick-initialized') && force) {
      $carousel.slick('unslick');
    }

    if (!$carousel.hasClass('slick-initialized')) {
      $carousel.slick(settings);
    }
  });
};

document.addEventListener('DOMContentLoaded', () => initCustomCarousels());

document.addEventListener('shopify:section:load', (event) => {
  initCustomCarousels(true);
});

let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    initCustomCarousels();
  }, 250);
});

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  initCustomCarousels();
}
